import  * as React from "react";
import { observer } from "mobx-react";
import { IOptimizerTutorialParams } from "./IOptimizerTutorialParams";

@observer
export class OptimizerTutorial extends React.Component<IOptimizerTutorialParams>{

    constructor(props: IOptimizerTutorialParams) {
        super(props, undefined);
        this.hideOptimizerTutorial = this.hideOptimizerTutorial.bind(this);
    }

    hideOptimizerTutorial(): void {
        this.props.hideOptimizerTutorial();
    }
    
    render() {
        return <div className="row OptimizerTutorial">
                   <div className="optimizer-tutorial style='opacity: 1'">
                       <div className="optimizer-text-container">
                           <p className="optimizer-tutorial-title">
                               <img src="Images/optimizer-icon-white.svg" alt="Optimizer icon"/><span>TrackMan Optimizer</span>
                           </p>
                           <p className="optimizer-tutorial-text">The TrackMan Optimizer uses your swing to determine your potential.</p>
                           <p className="optimizer-tutorial-text">Choose whether you would like a high, mid, or low ball flight and the optimizer will give you the launch numbers needed to achieve it.</p>
                           <div className="optimizer-buttons-container" onClick={this.hideOptimizerTutorial}>
                               <div className="ok-button">
                                   <span>OK - I understand </span>
                               </div>
                               <div className="do-not-show-again-checkbox" onClick={this.props.doNotShowOptimizerAgain}>
                                   <span>
                                       <img className="checkbox-icon" src="Images/checkbox.svg" alt="Checkbox ok"/>
                                       {this.props.showOptimizerTutorial === false &&
                                           <img className="checkbox-checked-icon" src="Images/checkbox-v.svg" alt="Checkbox"/>
                                       }
                                       Do not show again
                                   </span>
                               </div>
                           </div>
                       </div>
                   </div>
               </div>;
    }
}
